import React from "react";
import { useLang } from "../../context/LangContext";
import { useCMS } from "../../context/CMSContext";
import { useInView } from "../../hooks/useInView";
import SectionHeader from "../common/SectionHeader";
import Icon from "../common/Icon";
import { fonts } from "../../styles/tokens";
import styles from "./HowItWorks.module.css";

const STEP_ICONS = ["Search", "Upload", "MessageCircle", "Handshake"];

function HowItWorks() {
  const { t, lang = "en" } = useLang();
  const { cms } = useCMS();
  const [ref, visible] = useInView();

  // ── Data from CMS; fall back to translations ────────────────────────────────
  const cmsSteps = cms?.howItWorks?.steps;

  const steps =
    cmsSteps && cmsSteps.length > 0
      ? cmsSteps.map((s) => ({
          title: s[`title_${lang}`] || s.title_en || "",
          description: s[`desc_${lang}`] || s.desc_en || "",
        }))
      : t.howItWorks.steps;

  return (
    <section id="how-it-works" className={styles.section} ref={ref}>
      <div className={styles.bgGlow1} />
      <div className={styles.bgGlow2} />
      <div className="container" style={{ position: "relative", zIndex: 2 }}>
        <SectionHeader
          label={t.howItWorks.label}
          heading={t.howItWorks.heading}
          dark
        />
        <div className={styles.grid}>
          {steps.map((step, i) => (
            <div
              key={i}
              className={`${styles.card} ${visible ? styles.visible : ""}`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className={styles.iconCircle}>
                <Icon
                  name={STEP_ICONS[i % STEP_ICONS.length]}
                  size={24}
                  color="#fff"
                />
              </div>
              <div className={styles.stepNumber}>0{i + 1}</div>
              <h3
                style={{
                  fontFamily: fonts.display,
                  fontSize: 18,
                  fontWeight: 700,
                  color: "#fff",
                  margin: "0 0 10px",
                }}
              >
                {step.title}
              </h3>
              <p
                style={{
                  fontFamily: fonts.body,
                  fontSize: 14,
                  color: "rgba(255,255,255,0.5)",
                  lineHeight: 1.65,
                  margin: 0,
                }}
              >
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
